import { SharedLanguageService } from '@language';
import { SortDirection, SortOption } from '@stylehaven/components';
import { MetadataField } from '../record/entities/metadata-field.entity';
export const SortableFieldsToSortOptions = (
    fields: string[],
    translate: SharedLanguageService,
    defaultField: string = MetadataField.UserLastModifiedDate,
    defaultDirection: SortDirection = SortDirection.DESC,
    translateKey: string = 'components.sort.fields'
): SortOption[] => {
    return fields.flatMap(field => {
        return [SortDirection.ASC, SortDirection.DESC].map(
            direction =>
                ({
                    direction,
                    field,
                    label: translate.instant(`${translateKey}.${field}.${direction}`),
                    isDefault: field === defaultField && direction === defaultDirection
                } as SortOption)
        );
    });
};
